import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { isDarkMode, themeClasses: baseThemeClasses } = useTheme();

  const language = localStorage.getItem('language') || 'english';
  const direction = language === 'hebrew' ? 'rtl' : 'ltr';

  const themeClasses = {
    ...baseThemeClasses,
    textGreen: isDarkMode ? 'text-forest-ondark' : 'text-forest-ondark',
  };

  const content = {
    english: {
      title: '404 - Page Not Found',
      message: "The page you are looking for doesn't exist or has been moved.",
      button: 'Back to Dashboard',
    },
    hebrew: {
      title: '404 - הדף לא נמצא',
      message: 'הדף שחיפשת אינו קיים או שהועבר למיקום אחר.',
      button: 'חזרה לדשבורד',
    }
  };

  const t = content[language];

  return (
    /* Changed min-h-[80vh] to min-h-screen and added flex-col */
    <div 
      className={`min-h-screen w-full flex flex-col items-center justify-center p-4 ${themeClasses.bgPrimary} transition-colors duration-300`}
      style={{ margin: 0, paddingBottom: '10vh' }} // Slight offset so the card looks centered
      dir={direction}
    >
      <div className={`max-w-md w-full ${themeClasses.bgCard}  border ${themeClasses.borderPrimary} rounded-lg p-8 text-center `}>
        <div className="mb-6 text-6xl">🔍</div>
        
        <h1 className={`text-3xl font-bold mb-4 ${themeClasses.textPrimary}`}>
          {t.title}
        </h1>
        
        <p className={`mb-8 ${themeClasses.textMuted}`}>
          {t.message}
        </p>

        <button
          onClick={() => navigate('/client-dashboard')}
          className={`w-full py-3 px-6 rounded-lg font-bold text-white transition-all duration-300 transform hover:scale-[1.02]  ${
            isDarkMode 
              ? 'bg-forest-ondark hover:bg-forest-ondark/90' 
              : 'bg-forest-ondark hover:bg-forest-ondark/90'
          }`}
        >
          {t.button}
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;